// assets
import {
  IconHome,
  IconCalendarEvent,
  IconMail,
  IconFileUpload,
  IconFileInvoice,
  IconPhoneCall,
  IconAntennaBars5,
  IconChecklist,
  IconNotebook,
  IconPhoneCheck,
  IconUsers,
  IconSoup,
  IconHanger2,
  IconDoor,
  IconUserCircle,
  IconPackage,
  IconCoinRupee
} from '@tabler/icons';

// constant
const icons = {
  IconHome,
  IconCalendarEvent,
  IconMail,
  IconFileUpload,
  IconFileInvoice,
  IconPhoneCall,
  IconAntennaBars5,
  IconChecklist,
  IconNotebook,
  IconPhoneCheck,
  IconUsers,
  IconDoor,
  IconSoup,
  IconHanger2,
  IconCoinRupee,
  IconUserCircle,
  IconPackage
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
  // title: 'Dashboard-Menu',
  type: 'group',
  children: [
    {
      id: 'default',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard/app',
      icon: icons.IconHome,
      breadcrumbs: false
    },
    {
      id: '01',
      title: 'Room Management',
      type: 'item',
      url: '/dashboard/roommanagement',
      icon: icons.IconDoor,
      breadcrumbs: false
    },
    {
      id: '02',
      title: 'Reservation',
      type: 'item',
      url: '/dashboard/reservation',
      icon: icons.IconCalendarEvent,
      breadcrumbs: false
    },
    {
      id: '03',
      title: 'Staff Management',
      type: 'item',
      url: '/dashboard/staffmanagement',
      icon: icons.IconUsers,
      breadcrumbs: false
    },
    {
      id: '04',
      title: 'Restaurant',
      type: 'item',
      url: '/dashboard/restaurant',
      icon: icons.IconSoup,
      breadcrumbs: false
    },
    {
      id: '05',
      title: 'Customers',
      type: 'item',
      url: '/dashboard/customers',
      icon: icons.IconUsers,
      breadcrumbs: false
    },
    {
      id: '06',
      title: 'Reports',
      type: 'collapse',
      icon: icons.IconChecklist ,
      children:[
        {
          id: '101',
          title: 'Daily Sales Report',
          type: 'item',
          url: '/dashboard/reports',
          icon: icons.IconChecklist ,
          breadcrumbs: false
        },
        {
          id: '102',
          title: 'Police Report',
          type: 'item',
          url: '/dashboard/policyreports',
          icon: icons.IconChecklist ,
          breadcrumbs: false
        },
        {
          id: '103',
          title: 'General Report',
          type: 'item',
          url: '/dashboard/generalreport',
          icon: icons.IconChecklist ,
          breadcrumbs: false
        },
        {
          id: '104',
          title: 'Kot Report',
          type: 'item',
          url: '/dashboard/kotreports',
          icon: icons.IconChecklist ,
          breadcrumbs: false
        },
      ]
    },
    {
      id: '07',
      title: 'Complaint',
      type: 'item',
      url: '/dashboard/complaint',
      icon: icons.IconUsers,
      breadcrumbs: false
    },
    {
      id: '08',
      title: 'Kitchen Order Ticket',
      type: 'item',
      url: '/dashboard/kot',
      icon: icons.IconChecklist,
      breadcrumbs: false
    },
    {
      id: '09',
      title: 'Invoice',
      type: 'item',
      url: '/dashboard/invoice',
      icon: icons.IconFileInvoice,
      breadcrumbs: false
    },
    {
      id: '10',
      title: 'Laundary',
      type: 'item',
      url: '/dashboard/laundary',
      icon: icons.IconHanger2,
      breadcrumbs: false
    },
    {
      id: '11',
      title: 'Expenses',
      type: 'item',
      url: '/dashboard/expenses',
      icon: icons.IconCoinRupee,
      breadcrumbs: false
    },
    {
      id: '12',
      title: 'Subscriptions',
      type: 'item',
      url: '/dashboard/hotelsubscriptions',
      icon: icons.IconPackage,
      breadcrumbs: false
    },
    {
      id: '13',
      title: 'Payments',
      type: 'item',
      url: '/dashboard/hotelpayments',
      icon: icons.IconCoinRupee,
      breadcrumbs: false
    },
    {
      id: '14',
      title: 'Hotel Profile',
      type: 'item',
      url: '/dashboard/profile',
      icon: icons.IconUserCircle,
      breadcrumbs: false
    },
  ]
};


// ==============================||Hotel Admin DASHBOARD MENU ITEMS ||============================== //

const hoteladmindashboard = {
  // title: 'Dashboard-Menu',
  type: 'group',
  children: [
    {
      id: 'default',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard/app',
      icon: icons.IconHome,
      breadcrumbs: false
    },
    {
      id: '01',
      title: 'Room Management',
      type: 'item',
      url: '/dashboard/roommanagement',
      icon: icons.IconDoor,
      breadcrumbs: false
    },
    {
      id: '02',
      title: 'Reservation',
      type: 'item',
      url: '/dashboard/reservation',
      icon: icons.IconCalendarEvent,
      breadcrumbs: false
    },
    {
      id: '03',
      title: 'Staff Management',
      type: 'item',
      url: '/dashboard/staffmanagement',
      icon: icons.IconUsers,
      breadcrumbs: false
    },
    {
      id: '04',
      title: 'Restaurant',
      type: 'item',
      url: '/dashboard/restaurant',
      icon: icons.IconSoup,
      breadcrumbs: false
    },

    {
      id: '05',
      title: 'Reports',
      type: 'item',
      url: '/dashboard/reports',
      icon: icons.IconChecklist,
      breadcrumbs: false
    },
    {
      id: '06',
      title: 'Complaint',
      type: 'item',
      url: '/dashboard/complaint',
      icon: icons.IconUsers,
      breadcrumbs: false
    },
    {
      id: '07',
      title: 'Laundary',
      type: 'item',
      url: '/dashboard/laundary',
      icon: icons.IconHanger2,
      breadcrumbs: false
    },
    {
      id: '08',
      title: 'Expenses',
      type: 'item',
      url: '/dashboard/expenses',
      icon: icons.IconCoinRupee,
      breadcrumbs: false
    },

    {
      id: '09',
      title: 'Customers',
      type: 'item',
      url: '/dashboard/customers',
      icon: icons.IconUsers,
      breadcrumbs: false
    },
    {
      id: '10',
      title: 'Subscriptions',
      type: 'item',
      url: '/dashboard/hotelsubscriptions',
      icon: icons.IconPackage,
      breadcrumbs: false
    },
    {
      id: '11',
      title: 'Payments',
      type: 'item',
      url: '/dashboard/hotelpayments',
      icon: icons.IconCoinRupee,
      breadcrumbs: false
    },
    {
      id: '12',
      title: 'Hotel Profile',
      type: 'item',
      url: '/dashboard/profile',
      icon: icons.IconUserCircle,
      breadcrumbs: false
    }
  ]
};


// ==============================|| ADMIN DASHBOARD MENU ITEMS ||============================== //
const admindashboard = {
  // title: 'Dashboard-Menu',
  type: 'group',
  children: [
    {
      id: 'default',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard/admindashboard',
      icon: icons.IconHome,
      breadcrumbs: false
    },
    {
      id: '01',
      title: 'Hotel Management',
      type: 'item',
      url: '/dashboard/hotel',
      icon: icons.IconDoor,
      breadcrumbs: false
    },
    {
      id: '03',
      title: 'Support',
      type: 'item',
      url: '/dashboard/admincomplaint',
      icon: icons.IconUsers,
      breadcrumbs: false
    },
    {
      id: '04',
      title: 'Reports',
      type: 'item',
      url: '/dashboard/adminreports',
      icon: icons.IconChecklist,
      breadcrumbs: false
    },
    {
      id: '05',
      title: 'Packages',
      type: 'item',
      url: '/dashboard/subscriptions',
      icon: icons.IconPackage,
      breadcrumbs: false
    },
    {
      id: '06',
      title: 'Payments',
      type: 'item',
      url: '/dashboard/payments',
      icon: icons.IconCoinRupee,
      breadcrumbs: false
    }
  ]
};

export { dashboard, hoteladmindashboard, admindashboard };
